<template>
  <main>
    <vue-headful
      title="Contactez-nous - ADLCJ リヨン補習授業校"
      description="Pour toute question ou demande d'information, n'hésitez pas à nous contacter. Nous sommes à votre disposition pour répondre à vos besoins concernant les cours de japonais et l'école complémentaire à Lyon."
      url="https://adlcj.fr/contact"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
      type="article"
    />
    <section class="title">
      <div class="title-wrapper">
        <h1>{{ $t("contact.h1") }}</h1>
      </div>
      <div>
        <p>{{ $t("contact.desc") }} <img src="../assets/image/icons/emojione_smiling-face-with-smiling-eyes.svg" alt="" aria-hidden="true" class="descIcon" /></p>
      </div>
    </section>
    <contactFR v-if="$i18n.locale === 'fr'" />
    <contactJP v-else />
  </main>
</template>
    
<script>
import ContactFR from "../components/ContactFR.vue";
import ContactJP from "../components/ContactJP.vue";
export default {
  name: "Contact",
  components: {
    ContactFR,
    ContactJP
  }
};
</script>

<style lang="scss" scoped>
.descIcon {
  width: 1.1em;
  height: 1.1em;
  vertical-align: middle;
}
</style>